var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/navigation/navigationMain.vue
// module id = 710
// module chunks = 15